var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "quick-actions-container w-100" }, [
    _c(
      "form",
      {
        attrs: { id: "quick-activity-form" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            $event.stopPropagation()
          },
        },
      },
      [
        _c("div", { staticClass: "row justify-content-center mb-3" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("p", { staticClass: "bold text-primary mb-2" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("boards.messages.quickActivity")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "w-100" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "mb-2 col-12" },
                  [
                    _c("material-input", {
                      attrs: {
                        optional: "",
                        label: _vm.$t("global.words.description"),
                      },
                      model: {
                        value: _vm.quickFollowUp.description,
                        callback: function ($$v) {
                          _vm.$set(_vm.quickFollowUp, "description", $$v)
                        },
                        expression: "quickFollowUp.description",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "d-flex flex-column justify-content-end",
                    class: _vm.wrapInputs ? "col mb-2" : "col-12 col-lg-4",
                  },
                  [
                    _c("material-input", {
                      staticClass: "position-relative mb-2 fe-dp",
                      attrs: {
                        optional: "",
                        label: _vm.$t("global.doorr.scheduledDate"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var inputClasses = ref.inputClasses
                            return [
                              _c("datepicker-input", {
                                attrs: {
                                  id: "scheduled-date-label",
                                  name: "scheduledDate",
                                  "class-name":
                                    "date-format future-date " + inputClasses,
                                  "show-calendar": false,
                                  "future-date": "",
                                },
                                model: {
                                  value: _vm.quickFollowUp.scheduledDate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.quickFollowUp,
                                      "scheduledDate",
                                      $$v
                                    )
                                  },
                                  expression: "quickFollowUp.scheduledDate",
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.quickFollowUp.scheduledDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.quickFollowUp, "scheduledDate", $$v)
                        },
                        expression: "quickFollowUp.scheduledDate",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "d-flex flex-column justify-content-end",
                    class: _vm.wrapInputs ? "col mb-2" : "col-12 col-lg-4",
                  },
                  [
                    _c(
                      "material-input",
                      {
                        staticClass: "mb-2",
                        attrs: {
                          optional: "",
                          "hidden-label": "",
                          label: _vm.$t("global.words.time"),
                          "label-for": "time-label",
                        },
                        model: {
                          value: _vm.quickFollowUp.scheduledTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.quickFollowUp, "scheduledTime", $$v)
                          },
                          expression: "quickFollowUp.scheduledTime",
                        },
                      },
                      [
                        _c("time-input", {
                          attrs: {
                            id: "time-label",
                            required: "",
                            "default-value": _vm.followUpNotificationTime,
                          },
                          model: {
                            value: _vm.quickFollowUp.scheduledTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.quickFollowUp, "scheduledTime", $$v)
                            },
                            expression: "quickFollowUp.scheduledTime",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { class: _vm.wrapInputs ? "col-12" : "col-12 col-lg-4" },
                  [
                    _c("assignee-select", {
                      ref: "assigneeSelect",
                      staticClass: "w-100 mb-2",
                      attrs: {
                        label: "assignee select",
                        "client-profile-id": _vm.clientProfileId,
                        assignees: _vm.quickFollowUp.assignees || [],
                        "inline-edit": false,
                        board: _vm.selectedBoardId,
                        "hidden-label": "",
                      },
                      on: { change: _vm.handleNotifyChange },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("hr", {
      staticClass: "hr-text my-4 text-uppercase",
      attrs: {
        "data-content":
          _vm.$t("global.words.and") + " / " + _vm.$t("global.words.or"),
      },
    }),
    _vm._v(" "),
    _c(
      "form",
      {
        attrs: { id: "quick-note-form" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            $event.stopPropagation()
          },
        },
      },
      [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("p", { staticClass: "bold text-primary mb-2" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("boards.messages.quickNote")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "w-100" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "align-middle col-12 mb-2 position-relative" },
                  [
                    _c("material-input", {
                      attrs: {
                        optional: "",
                        label: _vm.$t("global.actions.enterDescription"),
                      },
                      model: {
                        value: _vm.noteDescription,
                        callback: function ($$v) {
                          _vm.noteDescription = $$v
                        },
                        expression: "noteDescription",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }